export default __webpack_public_path__ + "static/media/pilz-12.e8043351.png";